import { render, staticRenderFns } from "./CopyInvoiceDialog.vue?vue&type=template&id=4b6774de&"
import script from "./CopyInvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./CopyInvoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports